import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

const styles = {
  accordion: {
    boxShadow: 'none',
    border: 1,
    borderColor: 'divider',
    borderRadius: '12px !important',
    '&:before': { display: 'none' },
    '&.Mui-expanded': { m: 0 },
  },
  summary: { minHeight: 48, '&.Mui-expanded': { minHeight: 48 } },
  summaryContent: { display: 'flex', alignItems: 'center', gap: 1 },
  summaryTitle: (theme) => ({
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
  }),
  cellLabel: (theme) => ({
    fontSize: theme.typography.pxToRem(13),
    color: 'text.secondary',
    whiteSpace: 'nowrap',
    py: 1,
    px: 2,
    borderBottom: 1,
    borderColor: 'divider',
  }),
  cellValue: (theme) => ({
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 600,
    color: 'secondary.main',
    py: 1,
    px: 2,
    borderBottom: 1,
    borderColor: 'divider',
  }),
};

const PolicyDetailsAccordion = ({ title, rows, onFirstExpand }) => {
  const hasFired = useRef(false);

  const handleChange = (_event, expanded) => {
    if (expanded && !hasFired.current && onFirstExpand) {
      hasFired.current = true;
      onFirstExpand();
    }
  };

  return (
    <Accordion onChange={handleChange} sx={styles.accordion}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={styles.summary}>
        <Box sx={styles.summaryContent}>
          <DescriptionOutlinedIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
          <Typography sx={styles.summaryTitle}>
            {title}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0, maxHeight: 350, overflowY: 'auto' }}>
        <Table size='small'>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i}>
                <TableCell sx={styles.cellLabel}>{row.label}</TableCell>
                <TableCell sx={styles.cellValue}>{row.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  );
};

PolicyDetailsAccordion.propTypes = {
  onFirstExpand: PropTypes.func,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  title: PropTypes.string.isRequired,
};

export default PolicyDetailsAccordion;
